export default __webpack_public_path__ + "static/media/m4dz.7af5ea55.png";